import { render } from "./PublicationsList.vue?vue&type=template&id=0b5186dd"
import script from "./PublicationsList.vue?vue&type=script&lang=js"
export * from "./PublicationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__